export class Evento {

    title: string;
    description: string;
    start: Date;
    end: Date;
    horaInicial: Date;
    horaFinal: Date;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/model/evento.ts